import { toast } from 'react-toastify';
export const attachResponseInterceptor = (api) => {
    api.interceptors.response.use((response) => response, async (error) => {
        const requestUrl = error.config?.url;
        const responseError = {
            message: error.response?.data?.message || error.response?.data?.error || 'An error occurred',
            status: error.response?.status || 500,
            isSuccess: false
        };
        if (responseError.status === 500 && requestUrl !== '/users/userinfo') {
            toast.error(responseError.message);
        }
        else {
            console.log('Error:', responseError.message);
        }
        return Promise.reject(responseError);
    });
    return api;
};
